import React from 'react';
import PropTypes from 'prop-types';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const StockTooltip = ({ children, title, description, stockType }) => {
    return (
        <OverlayTrigger
            placement="top"
            overlay={
                <Tooltip className="puratos-tooltip">
                    <div className="puratos-tooltip__header">
                        <svg
                            className={`stock-dot stock-dot--${stockType.toLowerCase()}`}
                            xmlns="http://www.w3.org/2000/svg"
                            width="8"
                            height="8"
                            viewBox="0 0 8 8"
                            fill="none"
                        >
                            <circle cx="4" cy="4" r="4" />
                        </svg>
                        <p
                            className={`puratos-tooltip__title puratos-tooltip__title--${stockType.toLowerCase()}`}
                        >
                            {title}
                        </p>
                    </div>
                    <p className="puratos-tooltip__description">
                        {description}
                    </p>
                </Tooltip>
            }
        >
            {children}
        </OverlayTrigger>
    );
};

StockTooltip.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    stockType: PropTypes.string.isRequired,
};

export default StockTooltip;
